export default __webpack_public_path__ + "static/media/mpbg.9225b30d.png";